export { default as payloadFavicon } from './payload-favicon.svg'
export { default as payloadFaviconDark } from './payload-favicon-dark.png'
export { default as payloadFaviconLight } from './payload-favicon-light.png'
export { default as staticOGImage } from './static-og-image.png'
